import React, { useEffect, useState } from 'react';
import { Route, Routes, BrowserRouter } from 'react-router-dom';
import routes from './config/routes';
import AppContext from './Context';

export const LoaderToggleContext = React.createContext<{ loadingOn: () => void, loadingOff: () => void }>(
  {
    loadingOn: () => {console.log('Bad FC!!!')},
    loadingOff: () => {console.log('Bad FC!!!')}
  }
);

const Application: React.FC = () => {
  const [loading, setLoading] = useState(false);

  return (
    <AppContext>
      <div>
        <BrowserRouter>
          <LoaderToggleContext.Provider value={{
            loadingOff: () => setLoading(false),
            loadingOn: () => setLoading(true)
          }}>
            <div className={`modal__loading_bar ${loading ? 'active' : ''}`}></div>
            <Routes>
              {routes.map(route => (
                <Route
                  key={route.path}
                  path={route.path}
                  element={<route.component />}
                />
              ))}
            </Routes>
          </LoaderToggleContext.Provider>
        </BrowserRouter>

      </div>
    </AppContext>
  );
};

export default Application;

//<Button variant="contained">Authorise with square</Button>